module.exports = __webpack_public_path__ + "img/n_bg1.02b6f0db.jpg";